<template>
    <div class="page">
        <div class="change-pwd-box">
            <h2>密码已过期，请修改密码</h2>
            <p class="tip">密码需满足以下复杂度要求：</p>
            <el-form label-width="100px" size="small" style="margin-top: 20px">
                <el-form-item label="原密码">
                    <el-input type="password" v-model="oldPwd" placeholder="请输入原密码"></el-input>
                </el-form-item>
                <el-form-item label="新密码">
                    <el-input type="password" v-model="newPwd" placeholder="请输入新密码" @input="checkPwdStrength"></el-input>
                </el-form-item>
                <!-- 密码强度 -->
                <el-form-item v-if="newPwd" label="密码强度">
                    <div class="pwd-strength">
                        <div class="strength-bar">
                            <div :class="['bar', strengthLevel >= 0 ? 'active' : '', 'level-' + strengthLevel]"></div>
                            <div :class="['bar', strengthLevel >= 1 ? 'active' : '', 'level-' + strengthLevel]"></div>
                            <div :class="['bar', strengthLevel >= 2 ? 'active' : '', 'level-' + strengthLevel]"></div>
                        </div>
                        <span class="strength-text">{{ strengthText }}</span>
                    </div>
                </el-form-item>
                <!-- 规则提示 -->
                <el-form-item>
                    <div class="pwd-rules">
                        <p :class="newPwd.length >= 8 ? 'rule-pass' : 'rule-fail'">✓ 至少8位字符</p>
                        <p :class="checkKinds() >= 3 ? 'rule-pass' : 'rule-fail'">✓ 包含大写字母、小写字母、数字、特殊字符中的至少3种</p>
                        <p :class="!newPwd || !newPwd.toLowerCase().includes(userAccount.toLowerCase()) ? 'rule-pass' : 'rule-fail'">✓ 不能包含用户名</p>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitChange" :loading="loading">确认修改</el-button>
                    <el-button v-if="!isForced" @click="$router.back()">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChangePassword',
    data() {
        return {
            oldPwd: '',
            newPwd: '',
            strengthLevel: 0,
            strengthText: '',
            loading: false,
            userAccount: ''
        }
    },
    computed: {
        isForced() {
            return this.$route.query.forced === 'true'
        }
    },
    mounted() {
        let userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
        this.userAccount = userInfo.userAccount || ''
    },
    methods: {
        checkPwdStrength() {
            if (!this.newPwd) {
                this.strengthLevel = 0
                this.strengthText = ''
                return
            }
            let kinds = 0
            if (/[A-Z]/.test(this.newPwd)) kinds++
            if (/[a-z]/.test(this.newPwd)) kinds++
            if (/[0-9]/.test(this.newPwd)) kinds++
            if (/[^a-zA-Z0-9]/.test(this.newPwd)) kinds++
            if (this.newPwd.length >= 12 && kinds === 4) {
                this.strengthLevel = 2; this.strengthText = '强'
            } else if (this.newPwd.length >= 8 && kinds >= 3) {
                this.strengthLevel = 1; this.strengthText = '中'
            } else {
                this.strengthLevel = 0; this.strengthText = '弱'
            }
        },
        checkKinds() {
            if (!this.newPwd) return 0
            let kinds = 0
            if (/[A-Z]/.test(this.newPwd)) kinds++
            if (/[a-z]/.test(this.newPwd)) kinds++
            if (/[0-9]/.test(this.newPwd)) kinds++
            if (/[^a-zA-Z0-9]/.test(this.newPwd)) kinds++
            return kinds
        },
        submitChange() {
            if (!this.oldPwd || !this.newPwd) {
                this.$message.error('请填写完整信息')
                return
            }
            if (this.newPwd.length < 8) {
                this.$message.error('密码至少8位')
                return
            }
            if (this.checkKinds() < 3) {
                this.$message.error('密码必须包含大写字母、小写字母、数字、特殊字符中的至少3种')
                return
            }
            this.loading = true
            this.$http.request({
                url: this.$api.editUserPassword,
                method: 'POST',
                params: {
                    oldPassWord: this.oldPwd,
                    newPassWord: this.newPwd
                }
            }).then(resp => {
                this.loading = false
                if (resp.status === 100) {
                    this.$message.success('密码修改成功')
                    this.$router.push({ path: '/home' })
                } else {
                    this.$message.error(resp.message)
                }
            }).catch(() => {
                this.loading = false
                this.$message.error('请求失败')
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: #f0f2f5;
}
.change-pwd-box {
    width: 480px;
    padding: 30px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.1);
    h2 { text-align: center; margin-bottom: 10px; }
    .tip { text-align: center; color: #909399; font-size: 13px; }
}
.pwd-strength {
    display: flex; align-items: center; gap: 10px;
    .strength-bar {
        display: flex; gap: 4px;
        .bar {
            width: 50px; height: 6px; border-radius: 3px; background: #e0e0e0;
            &.active.level-0 { background: #f56c6c; }
            &.active.level-1 { background: #e6a23c; }
            &.active.level-2 { background: #67c23a; }
        }
    }
    .strength-text { font-size: 12px; color: #909399; }
}
.pwd-rules {
    p { margin: 3px 0; font-size: 12px; }
    .rule-pass { color: #67c23a; }
    .rule-fail { color: #909399; }
}
</style>